import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DataTableDirective } from 'angular-datatables';

import { Subject } from 'rxjs/Rx';
declare var $: any;
import * as _ from 'lodash';
import { BranchAndDepartmentService } from 'src/app/services/branch-and-department.service';
import { AlertComponent } from '../../alert/alert.component';
import { LoaderService } from 'src/app/services/loader.service';

@Component({
  selector: 'app-department',
  templateUrl: './department.component.html',
  styleUrls: ['./department.component.css']
})
export class DepartmentComponent implements OnInit {

  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;

  departmentForm: FormGroup;
  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();
  responseDepartment: any;
  deleteDepartmentId: any;
  departmentId: any;
  errorMessage: any;

  constructor(public branchAndDepartmentService: BranchAndDepartmentService, private alert: AlertComponent, private loaderService: LoaderService) {
    this.departmentForm = new FormGroup({
      departmentName: new FormControl('', [Validators.required]),
      departmentId: new FormControl('', [Validators.required]),
      emailId: new FormControl('', [Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")]),
      escalation_1: new FormControl('', [Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")]),
      escalation_2: new FormControl('', [Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")]),
    })
  }

  ngOnInit(): void {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      scrollX: true,
      scrollY: '420px',
      scrollCollapse: true,
      stateSave: true,
      dom: 'lBfrtip',
      processing: true,
      serverSide: false,
      buttons: [
        {
          text: '<i class="fa fa-files-o"></i> Export to Excel',
          className: 'btn btn-sm btn-warning export-btn',
          filename: 'Committee List',
          title: 'Committee List',
          extend: 'excel',
          exportOptions: {
            columns: [0, 1, 2, 5],
            format: {
              body: (data: any) => {
                if (
                  data.includes("+") || data.includes("@") ||
                  data.includes("=") || data.includes("|") ||
                  data.includes("!")
                ) {
                  if (data.match(/^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+\.[a-zA-Z0-9.-]+$/)) {
                    return data;
                  } else {
                    return "'" + data + "'";
                  }
                } else {
                  return data;
                }
              }
            }
          }
        }
      ],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
    };
  
    this.onGetDepartmentDetails();
  }
  
  ngOnDestroy(): void {
    // Re-enable loader when navigating away from this component
    this.loaderService.enable();
  }
  onSave() {
    if (this.departmentId) {
      this.onUpdate();
    } else {
      this.branchAndDepartmentService.addDepartment(this.departmentForm.value).subscribe((response: any) => {
        
        if (response.status == 0) {
          $('#departmentModel').modal('hide');
          this.alert.successWithOk1("Department created successfully", () => {
            $('#departmentModel').off('hidden.bs.modal');
            $('.modal-backdrop').remove();
            $('body').removeClass('modal-open');
            this.onGetDepartmentDetails();
          });
          this.departmentForm.reset();
        }
        else {
          $('#departmentModel').modal('hide');
          this.alert.error1(JSON.stringify(response.message), () => {
            $('#departmentModel').off('hidden.bs.modal');
            $('.modal-backdrop').remove();
            $('body').removeClass('modal-open');
            this.onGetDepartmentDetails();
          });
        }
      }, err => {
        $('#departmentModel').modal('hide');
      })
    }
  }


  add() {
    //$('#departmentModel').modal('toggle');
    // Clean any leftover state just to be safe
    this.loaderService.disable();
    $('.modal-backdrop').remove();
    $('body').removeClass('modal-open');
    $('#departmentModel').removeClass('show').hide();

    setTimeout(() => {
      $('#departmentModel').modal('show');
    }, 100);
  }
  onGetDepartmentDetails(): void {
    this.loaderService.enable();
    this.branchAndDepartmentService.getDepartment().subscribe((response: any) => {
      this.responseDepartment = response.data;
  
      this.rerenderDepartmentTable();
    }, err => {
      console.error("Error fetching department data:", err);
    });
  }
  rerenderDepartmentTable(): void {
    if (this.dtElement?.dtInstance) {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
        this.dtTrigger.next();
      });
    } else {
      this.dtTrigger.next();
    }
  }

  onDeleteDepartment(id) {
    this.deleteDepartmentId = id;
    $('#confirmation').modal('toggle');
  }

  deleteDepartment() {
    this.branchAndDepartmentService.deleteDepartment(this.deleteDepartmentId).subscribe(resp => {
      $('#confirmation').modal('toggle');
      this.onGetDepartmentDetails();
      this.alert.success("Department deleted successfully");
    }, error => {
      console.log("🚀 ~ file: branch.component.ts ~ line 149 ~ BranchComponent ~ this.branchAndDepartmentService.deleteBranch ~ error", error)
    })
  }

  onClose() {
    $('#confirmation').modal('toggle');
  }

  onEdit(department) {
    this.departmentForm.patchValue(department);
    this.departmentId = department._id;
    $('#departmentModel').modal('toggle');
  }

  onUpdate() {
    this.departmentId;
    this.branchAndDepartmentService.update(this.departmentId, this.departmentForm.value).subscribe(respData => {
      $('#departmentModel').modal('toggle');
      this.departmentId = null;
      this.departmentForm.reset();
      this.alert.success("Department updated successfully");
      this.onGetDepartmentDetails();
    }, error => {
      console.log("🚀 ~ file: department.component.ts ~ line 119 ~ DepartmentComponent ~ this.branchAndDepartmentService.update ~ error", error)
    })
  }

  onChange(key, event) {
    this.branchAndDepartmentService.checkBranch({ [key]: event.target.value, _id: { $ne: this.departmentId } }).subscribe((resData: any) => {
      if (resData.code == 0) {
        this.departmentForm.controls[key].setErrors({ [key]: true });
        this.errorMessage = { [key]: `${event.target.value} is already exists` }
      } else {
        if (this.departmentForm.invalid) {
          this.departmentForm.controls[key].setErrors({ [key]: false });
        }
        this.errorMessage = { [key]: false }
      }
    }, error => {
      console.log("🚀 ~ file: branch.component.ts ~ line 136 ~ BranchComponent ~ this.branchAndDepartmentService.checkBranch ~ error", error)
    })
  }

  restForm() {
    this.departmentForm.reset();
  }
}

